import { render, staticRenderFns } from "./List.vue?vue&type=template&id=e180ca80&"
import script from "./List.vue?vue&type=script&lang=js&"
export * from "./List.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\RobertWiberg\\source\\repos\\server-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e180ca80')) {
      api.createRecord('e180ca80', component.options)
    } else {
      api.reload('e180ca80', component.options)
    }
    module.hot.accept("./List.vue?vue&type=template&id=e180ca80&", function () {
      api.rerender('e180ca80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AddressBook/List.vue"
export default component.exports